import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import firebase from 'firebase/app'
import 'firebase/analytics'
import 'bootstrap/dist/css/bootstrap.min.css'
import './styles.css'
import * as serviceWorker from './serviceWorker'
import ReactGA from 'react-ga'
import { createBrowserHistory as createHistory } from 'history'
import { BrowserRouter as Router } from 'react-router-dom'
import LoginView from './views/LoginView'
import Firebase, { FirebaseContext } from './components/Firebase'

var firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGINGSENDERID,
  appId: process.env.REACT_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENTID,
}

firebase.initializeApp(firebaseConfig)

const analytics = firebase.analytics()

// import Auth from './Auth';

const host = window.location.hostname
// const auth = new Auth();
// TODO: Change this tracking ID
const GA_ID = ''

// TODO: Change this URL
if (host === '') {
  ReactGA.initialize(GA_ID)
}

const history = createHistory()

if (host !== 'localhost') {
  history.listen((location, action) => {
    const page = host + location.pathname
    ReactGA.set({ page })
    ReactGA.pageview(page)
  })
}

ReactDOM.render(
  <Router basename="/">
    <FirebaseContext.Provider value={new Firebase()}>
      <App />
    </FirebaseContext.Provider>
  </Router>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
